import clsx from "clsx";
import Image from "components/Elements/Image/Image";
import Button from "components/Elements/Button/Button";
import styles from "./joinCustomDomainOrgBanner.module.scss";

import { Dispatch, memo, SetStateAction, useEffect } from "react";
import type { AuthModalTypeT } from "../../models/models";
import { useContent } from "contexts/contentContext/contentContext";
import useOrganization from "hooks/useOrganization";

interface JoinCustomDomainOrgBannerI
  extends React.HTMLAttributes<HTMLDivElement> {
  setModalType: Dispatch<SetStateAction<AuthModalTypeT>>;
  subUserDomain: string;
}

const JoinCustomDomainOrgBanner = memo((props: JoinCustomDomainOrgBannerI) => {
  const { className, subUserDomain, setModalType, ...restProps } = props;

  const { getTextByKey } = useContent();

  const { logo, fetchLogo } = useOrganization();

  useEffect(() => {
    fetchLogo();
  }, []);

  return (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      <div className={styles.logoWrapper}>
        <Image src={logo} />
      </div>
      <h1>
        {getTextByKey("join-to-domain").replace("#DomainName#", subUserDomain)}
      </h1>
      <div className={styles.signInWrapper}>
        <p>{getTextByKey("signin-already-a-member-text")}</p>
        <Button onClick={() => setModalType("sign-in")}>
          {getTextByKey("signin-already-a-member-link")}
        </Button>
      </div>
    </div>
  );
});

export default JoinCustomDomainOrgBanner;
